<template>
    <div class="TFA">
        <v-alert class="TFA_error" v-if="showError" :type="typeAlert" :icon="false" :dismissible="false" dense>{{ messageAlert }}</v-alert>

        <form @submit.prevent="sentTwoFACode">
            <h2 class="TFA_title text-h5">2 Factor Authentication</h2>
            <div><p>Please enter your verification code.</p></div>
            <div class="TFA_field twofa">
                <label for="twofa">Enter Verification Code</label>
                <input v-model="twofa" placeholder="Enter Verification Code" type="text" maxlength="8">
            </div>
            <div class="TFA_submit my-5">
                <v-btn color="primary" type="submit" link>Verify Code</v-btn>
            </div>
            <div class="TFA_submit_links d-flex gap-20 justify-center">
                <a class="link" href="#" @click.prevent="returnLogin">Back to Login</a>
                <a class="link" href="#" @click.prevent="resendCode">Resend Code</a>
            </div>
        </form>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { RouterLink } from 'vue-router';
export default {
    name: 'TwoFACode',
    data() {
        return {
            twofa: null,
            showError: false,
            messageAlert: '---Error---',
            typeAlert:'error'
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
    },
    methods: {
        ...mapActions(["check2FALogin", "resendTwoFACode", "logOut"]),

        async returnLogin() {
            await this.logOut();
            this.$router.go(0);
        },
        async sentTwoFACode() {
            this.showError = false;
            if(this.user.id !== undefined){
                const params = new FormData();
                params.append('admin_id',this.user.id);
                params.append('twofa',this.twofa);
                try {
                    const response = await this.check2FALogin(params);
                    const data = response.data.data;
                    if(data.result==='success'){
                        this.user.isLogin = true;
                        this.$store.commit( 'setUser', this.user);
                        this.$router.go(0);
                    }else{
                        this.messageAlert = data.error.twofa;
                        this.showError = true;
                    }
                } catch (error) {
                    console.error(error);
                }
            }else{
                console.log('Return to login');
            }
            setTimeout(()=>{ this.showError= false},3e3);
        },
        async resendCode() {
            this.typeAlert = 'error';
            if(this.user.id !== undefined){
                const params = new FormData();
                params.append('admin_id',this.user.id);
                try {
                    const response = await this.resendTwoFACode(params);
                    const data = response.data.data;
                    if(data.result === 'success'){
                        this.typeAlert = 'success';
                        this.messageAlert = ' Please check again your email in a few seconds.';
                        this.showError= true;
                    }
                } catch (error) {
                    console.error(error);
                    this.typeAlert = 'error';
                    this.showError= true;
                    this.messageAlert = error;
                }
                setTimeout(()=>{ 
                    this.showError= false;
                    this.typeAlert = 'error';
                },3e3);
            }
        }
        
    }
}
</script>

<style lang="scss" scoped>
  @import '~@/scss/colors.scss';
    .TFA{
        text-align: center;
        &_error{
            font-size: 12px;
            text-align: center;
        }
        &_title{
            color: $purple;
        }
        &_field{
            display: block;
            margin-bottom: 20px;
            position: relative;
            label{
                width: 0;
                height: 0;
                visibility: hidden;
                position: absolute;
                opacity: 0;
            }
            input{
                font-size: 14px;
                display: block;
                width: 100%;
                height: 35px;
                padding: 0 20px;
                border: 1px solid #BFBFBF;
                border-radius: 4px;
                &::placeholder{
                color: #BFBFBF;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Login/TwoFACode.vue